/**
 * STAY AWAY.
 * CULT. 
 * IS WATCHING YOU
 * BEWARE
 * TRESPASSING WON'T BE TOLERATED
 * 
 * CULT
 */

import React from 'react';
import { getDefaultConfig, RainbowKitProvider, darkTheme } from '@rainbow-me/rainbowkit';
import { WagmiProvider } from 'wagmi';
import { mainnet, sepolia } from 'wagmi/chains';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import '@rainbow-me/rainbowkit/styles.css';
import './App.css';

import Home from './pages/Home';

const monadTestnet = {
  id: 10143,
  name: 'Monad Testnet',
  network: 'monad-testnet',
  nativeCurrency: {
    decimals: 18,
    name: 'MON',
    symbol: 'MON',
  },
  rpcUrls: {
    public: { http: ['https://testnet-rpc.monad.xyz/'] },
    default: { http: ['https://testnet-rpc.monad.xyz/'] },
  },
  blockExplorers: {
    default: { 
      name: 'Monad Explorer', 
      url: 'https://testnet.monadexplorer.com/' 
    },
  },
  testnet: true,
};

const config = getDefaultConfig({
  appName: process.env.REACT_APP_PROJECT_NAME || 'MON Cultists',
  projectId: process.env.REACT_APP_WALLETCONNECT_PROJECT_ID,
  chains: [
    mainnet,
    sepolia,
    monadTestnet
  ],
  ssr: true,
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5000,
      retry: 2,
    },
  },
});

function App() {
  return (
    <div>
      <div class="glyph">⛧</div>
      <div class="glyph">ᛟ</div>
      <div class="glyph">ᚲ</div>
      <div class="glyph">☽</div>
      <div class="glyph">☾</div>
      <div class="glyph">Ϟ</div>
      <div class="glyph">ᛣ</div>
      <div class="glyph">⛧</div>
      <div class="glyph">ᛟ</div>
      <div class="glyph">ᚲ</div>
      <div class="glyph">☽</div>
      <div class="glyph">☾</div>
      <div class="glyph">Ϟ</div>
      <div class="glyph">ᛣ</div>
      <div class="glyph">⛧</div>
      <div class="glyph">ᛟ</div>
      <div class="glyph">ᚲ</div>

      <WagmiProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <RainbowKitProvider locale="en-US" theme={darkTheme()}>
            <Home />

          </RainbowKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </div>
  );
}

export default App;